module.exports = __webpack_public_path__ + "static/media/arrow_down.08820d21.svg";